// Channels hidden from every HROAS surface for the Tinuiti Live demo.
// Filter is applied at the data-fetch layer so all downstream charts/tables
// receive pre-filtered rows. To re-enable a channel, remove it from the set.
const HIDDEN_CHANNELS = new Set(['podcast', 'super bowl']);

export const isHiddenChannel = (channel: string | undefined | null): boolean =>
  Boolean(channel) && HIDDEN_CHANNELS.has((channel as string).trim().toLowerCase());
